module.exports = __webpack_public_path__ + "img/gls-pp-icon.d63fb79.jpg";